module.exports = __webpack_public_path__ + "img/cameraVideo.9af822c0.svg";